import { Injectable, signal } from '@angular/core';

/**
 * User Init Service
 *
 * Tracks whether user-initialization has completed in the current session.
 * Used by authGuard to ensure users go through /loading before accessing
 * protected routes, while allowing /setup-profile for users who need to
 * create their account document.
 *
 * In-memory only — resets on page refresh, so users re-initialize on reload.
 */
@Injectable({
  providedIn: 'root',
})
export class UserInitService {
  private readonly _complete = signal(false);

  /** Reactive form of `initComplete`, for effects that wait for start-up. */
  readonly complete = this._complete.asReadonly();

  get initComplete(): boolean {
    return this._complete();
  }

  setInitComplete(): void {
    this._complete.set(true);
  }

  reset(): void {
    this._complete.set(false);
  }
}
